<template>
    <div>
        <CList v-if="VerListado != false" @FiltrarC="ListaFisico" :pConfigList="ConfigListFisico" :pFiltro="FiltroFisico" :segurity="segurity">
            
            <template slot="Filtros">
                <div class="col-auto">
                    <select v-model="TipoListado" @change="CambiarVistaListado()" class="form-select">
                        <option value="0">Pedidos</option>
                        <option value="1">Pedidos Fisicos</option>
                    </select>
                </div>
            </template>

            <template slot="header">
                <th :class="StyleTh+' text-center'">Folio</th>
                <th :class="StyleTh">Cliente</th>
                <th :class="StyleTh">Fecha</th>
                <th :class="StyleTh">Estatus Pedido</th>
                <th :class="StyleTh">Estatus</th>
                
                <th :class="StyleTh+' text-center'">Acciones</th>
            </template>

            <template slot="body">
                <tr v-for="(lista,index) in ListaArrayRows2" :key="index">
                    <td class="text-center"><h6 :class="StylePr">{{lista.FolioFisico}}</h6></td>
                    <td><p :class="StyleTd" v-if="lista.cliente">{{lista.cliente.Nombre}}</p></td>
                    <td><p :class="StyleTd">{{$getCleanDate(lista.Fecha)}}</p></td>
                    <td class="text-center">
                        <span v-if="lista.EstatusPedido == 'Pendiente'" class="badge text-bg-secondary" style="width: 150px !important">{{ lista.EstatusPedido }}</span>
                        <span v-if="lista.EstatusPedido == 'Recibido'" class="badge badge-blue" style="width: 150px !important">{{ lista.EstatusPedido }}</span>
                        <span v-if="lista.EstatusPedido == 'Material Pendiente'" class="badge badge-yellow text-black" style="width: 150px !important">{{ lista.EstatusPedido }}</span>
                        <span v-if="lista.EstatusPedido == 'En Produccion'" class="badge text-bg-info" style="width: 150px !important">{{ lista.EstatusPedido }}</span>
                        <span v-if="lista.EstatusPedido == 'Finalizado'" class="badge badge-purple" style="width: 150px !important">{{ lista.EstatusPedido }}</span>
                        <span v-if="lista.EstatusPedido == 'Enviado'" class="badge text-bg-success" style="width: 150px !important">{{ lista.EstatusPedido }}</span>
                        <span v-if="lista.EstatusPedido == 'Cancelado'" class="badge text-bg-danger" style="width: 150px !important">{{ lista.EstatusPedido }}</span>
                        <span v-if="arrEstatusBase.includes(lista.EstatusPedido) === false" class="badge text-bg-secondary">{{ lista.EstatusPedido }}</span>
                    </td>
                    <td>
                        <span v-if="lista.Estatus == 'Pendiente'" class="badge text-bg-secondary" style="width: 150px !important">{{ lista.Estatus }}</span>
                        <span v-if="lista.Estatus == 'Recibido'" class="badge badge-blue" style="width: 150px !important">{{ lista.Estatus }}</span>
                    </td>
                    <td class="align-middle text-end">
                        <CBtnAccion :pShowBtnEdit="false" :pShowBtnDelete="false" :pIsModal="true" :pId="lista.IdPedidoFisico" :pEmitSeccion="ConfigListFisico.EmitSeccion" :segurity="segurity">
                            <template slot="btnaccion">

                                <template ><!-- v-if="segurity.ChangeStatus" -->
                                    <button @click="ModalEstatusFisico(lista)" v-b-tooltip.hover.Top title="Cambiar Estatus" class="btn btn-success btn-icon btn-sm rounded me-2" type="button">
                                        <i class="fas fa-exchange"></i>
                                    </button>
                                </template>

                                <template v-if="segurity.Edit">

                                    <template v-if="lista.Archivo =='' || lista.Archivo ==null">
                                        <button type="button" @click="ModalArchivo(lista);" class="btn btn-link text-primary px-3 mb-0 mr-1" v-b-tooltip.hover.Top title="Cargar Archivo">
                                            <i class="fa fa-upload"></i> Cargar
                                        </button>
                                    </template>
                                </template>

                                <template v-if="lista.Archivo !='' && lista.Archivo!=null">
                                    <a class="btn btn-link text-warning px-3 mb-0 mr-1" :href="RutaFile+lista.Archivo" target="_blank">
                                        <i class="fa fa-file-pdf"></i> Pdf
                                    </a>
                                </template>

                                
                            </template>
                        </CBtnAccion>
                    </td>
                </tr>
            </template>

        </CList>
        
        <CList v-else @FiltrarC="Lista" :pConfigList="ConfigList" :pFiltro="Filtro" :segurity="segurity">
            <template slot="Filtros">
                <div class="col-auto">
                    <select v-model="TipoListado" @change="CambiarVistaListado()" class="form-select">
                        <option value="0">Pedidos</option>
                        <option value="1">Pedidos Fisicos</option>
                    </select>
                </div>
            </template>
            
            <template slot="header">
                <th :class="StyleTh+' text-center'">Folio</th>
            
                    <th :class="StyleTh">Cliente</th>
                    <th :class="StyleTh">Fecha</th>
                    <th :class="StyleTh">Paciente</th>
                    <th :class="StyleTh">Artículo</th>
                    <th :class="StyleTh">Estatus</th>
                    
                <th :class="StyleTh+' text-center'">Acciones</th>
            </template>

            <template slot="body">
                <tr v-for="(lista,index) in ListaArrayRows" :key="index">

                    <td v-if="isCotizacion" class="text-center"><h6 :class="StylePr">{{lista.FolioCotizacion}}</h6></td>
                    <td v-else class="text-center"><h6 :class="StylePr">{{lista.FolioPedido}}</h6></td>

                    <td><p v-if="lista.cliente != undefined && lista.cliente != null && lista.cliente != '' " :class="StyleTd">{{lista.cliente.Nombre}}</p></td>
                    <td><p :class="StyleTd">{{$getCleanDate(lista.Fecha,false)}}</p></td>
                    <td><p :class="StyleTd">{{lista.Paciente}}</p></td>
                    <td><p :class="StyleTd">{{lista.Articulo}}</p></td>

                    <td class="text-center">
                        <span v-if="lista.Estatus == 'Pendiente'" class="badge text-bg-secondary" style="width: 150px !important">{{ lista.Estatus }}</span>
                        <span v-if="lista.Estatus == 'Recibido'" class="badge badge-blue" style="width: 150px !important">{{ lista.Estatus }}</span>
                        <span v-if="lista.Estatus == 'Material Pendiente'" class="badge badge-yellow text-black" style="width: 150px !important">{{ lista.Estatus }}</span>
                        <span v-if="lista.Estatus == 'En Produccion'" class="badge text-bg-info" style="width: 150px !important">{{ lista.Estatus }}</span>
                        <span v-if="lista.Estatus == 'Finalizado'" class="badge badge-purple" style="width: 150px !important">{{ lista.Estatus }}</span>
                        <span v-if="lista.Estatus == 'Enviado'" class="badge text-bg-success" style="width: 150px !important">{{ lista.Estatus }}</span>
                        <span v-if="lista.Estatus == 'Cancelado'" class="badge text-bg-danger" style="width: 150px !important">{{ lista.Estatus }}</span>
                        <span v-if="arrEstatusBase.includes(lista.Estatus) === false" class="badge text-bg-secondary">{{ lista.Estatus }}</span>
                    </td>
                    


                    <td class="align-middle text-end">
                        <CBtnAccion :pShowBtnEdit="isCotizacion" :pShowBtnDelete="isCotizacion" :pIsModal="false" :pId="lista.IdPedido" :pEmitSeccion="ConfigList.EmitSeccion" :pGoRoute="ConfigList.GoRoute" :segurity="segurity">
                            <template slot="btnaccion">
                                
                                <template v-if="segurity.ChangeStatus">
                                    <button v-if="isCotizacion === false" @click="ModalEstatus(lista)" v-b-tooltip.hover.Top title="Cambiar Estatus" class="btn btn-success btn-icon btn-sm rounded me-2" type="button">
                                        <i class="fas fa-exchange"></i>
                                    </button>
                                </template>

                                <template v-if="segurity.PreviewOrder">
                                    <button v-if="isCotizacion === false " @click="viewResumen(lista)" v-b-tooltip.hover.Top title="Vista Previa" class="btn btn-primary btn-icon btn-sm rounded me-2" type="button">
                                        <i class="fas fa-eye"></i>
                                    </button>
                                </template>

                                <button @click="VerPdf(lista)" v-b-tooltip.hover.Top title="Ver Recibo" class="btn btn-warning btn-icon btn-sm rounded me-2" type="button">
                                    <i class="fas fa-file-pdf"></i>
                                </button>

                                <template v-if="segurity.RequestGuide">
                                    <button @click="SolcitarGuia(lista)" v-b-tooltip.hover.Top title="Solicitar Guia" class="btn btn-ligth btn-icon btn-sm rounded me-2" type="button">
                                        <i class="fas fa-shipping-fast"></i>
                                    </button>
                                </template>

                                

                                <span v-if="isCotizacion === false " class="spanBtnPrincipal ">
                                    <span class="reaction-btn-text btn btn-link text-secondary mb-0">
                                        <i class="fa fa-ellipsis-v text-xs" aria-hidden="true"></i>
                                    </span>
                                    <div class="divBoxIcons">
                                        <ul class="boxIcons">
                                            <template v-if="segurity.RequestWarranty">
                                                <template v-if="lista.Estatus == 'Finalizado'">
                                                    <li class="btnIcons" @click="ModalGarantia(lista)" v-if="lista.ExisteGarantia == 0">
                                                        <a class="dropdown-item">
                                                            <i class="fas fa-award text-danger"></i> Solicitar Garantia
                                                        </a>
                                                    </li>
                                                </template>
                                            </template>
                                        </ul>
                                    </div>
                                </span>

                                

                            </template>
                        </CBtnAccion>     
                    </td>
                </tr>
                <CSinRegistros :pContIF="ListaArrayRows.length" :pColspan="80"></CSinRegistros>
            </template>

            <template slot="body"></template>
        </CList>
        
        <CModal :pConfigModal="ConfigModalResumen" :poBtnSave="oBtnSaveResumen">
            <template slot="Form">
                <ResumenPedido :poBtnSave="oBtnSaveResumen" :pOrigen="'Listado'"></ResumenPedido>
            </template>
        </CModal>

        <CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
            <template slot="Form">
                <Form :poBtnSave="oBtnSave"></Form>
            </template>
        </CModal>

        <CModal :pConfigModal="ConfigModalFisico" :poBtnSave="oBtnSaveFisico">
            <template slot="Form">
                <Form2 :poBtnSave="oBtnSaveFisico"></Form2>
            </template>
        </CModal>

        <CModal :pConfigModal="ConfigModal2" :poBtnSave="oBtnSave2">
            <template slot="Form">
                <FormEstatus :poBtnSave="oBtnSave2"></FormEstatus>
            </template>
        </CModal>

        <CModal :pConfigModal="ConfigModalArchivo" :poBtnSave="oBtnSaveArchivo">
            <template slot="Form">
                <FormArchivo :poBtnSave="oBtnSaveArchivo"></FormArchivo>
            </template>
        </CModal>

        <CModal :pConfigModal="ConfigModal3" :poBtnSave="oBtnSave3">
            <template slot="Form">
                <FormEstatusFisico :poBtnSave="oBtnSave3"></FormEstatusFisico>
            </template>
        </CModal>
    </div>
</template>
<script>

import moment from 'moment';
import Configs from '@/helpers/VarConfig.js';
import Form from '@/views/modulos/garantias/Form.vue';
import Form2 from '@/views/modulos/pedidosFisicos/FormFisico.vue';
import FormEstatus from '@/views/modulos/pedidos/estatuspedido/ListFormModal.vue';
import FormEstatusFisico from '@/views/modulos/pedidos/estatuspedido/ListFormModalFisico.vue';
import FormArchivo from '@/views/modulos/pedidosFisicos/FormArchivo.vue';
import ResumenPedido from './ResumenPedido.vue';

const EmitEjecuta = 'seccionPedido';
const EmitEjecuta2 = 'seccionGarantia';
const EmitEjecuta3 = 'seccionFisica';
const EmitEjecuta4 = 'seccionEstatus';
const EmitEjecuta5 = 'seccionArchivo';
const EmitEjecuta6 = 'seccionResumenPedido';
const EmitEjecuta7 = 'seccionEstatusFisico';

export default {
    name: 'ListaPedido',
    props: ['sFiltros','pOrigen'],
    components: {
        Form,
        Form2,
        FormEstatus,
        FormArchivo,
        ResumenPedido,
        FormEstatusFisico,
    },
    data() {
        return {
            
            arrEstatusBase: ['Pendiente','Recibido','Material Pendiente','En Produccion','Finalizado','Enviado','Cancelado'],
            ConfigList:{
                Title: 'Listado de ',
                IsModal: false,
                /*ShowYear: true,*/
                ShowLoader: true,
                EmitSeccion: EmitEjecuta,
                BtnReturnShow: false,
                ShowTitleFirst: false,
                TitleFirst: '',
                GoRoute: 'formpedidos',
                Obj:{
                    pOrigen: ''
                }
            },
            Filtro:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            ConfigModal:{
                ModalTitle: "Solicitud Garantia",
                ModalNameId: 'ModalForm',
                ModalSize: 'xl',
                EmitSeccion: EmitEjecuta2,
            },
            ConfigModal2:{
                ModalTitle: "Cambiar Estatus",
                ModalNameId: 'ModalForm3',
                ModalSize: 'xl',
                EmitSeccion: EmitEjecuta4,
                ShowFooter:false
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta2,
                ShowBtnSave: false,
            },
            oBtnSave2:{
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta4,
            },

            ConfigListFisico:{
                Title: 'Listado de Pedidos Fisicos',
                IsModal: true,
                ShowLoader: true,
                EmitSeccion: EmitEjecuta3,
                BtnReturnShow: false,
                ShowTitleFirst: false,
                TitleFirst: '',
                Obj:{
                    pOrigen: ''
                }
            },
            FiltroFisico:{
                Nombre: '',
                Pagina: 1,
                Entrada: 25,
                TotalItem: 0,
                Placeholder: 'Buscar..',
                /*Anio: moment(new Date()).format('YYYY'),*/
            },
            ConfigModalFisico:{
                ModalTitle: "Pedidos",
                ModalNameId: 'ModalForm2',
                ModalSize: 'xl',
                EmitSeccion: EmitEjecuta3,
            },
            oBtnSaveFisico: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta3,
            },
            ConfigModalArchivo:{
                ModalTitle: "Archivo: ",
                ModalNameId: 'ModalForm4',
                ModalSize: 'lg',
                EmitSeccion: EmitEjecuta5,
            },
            oBtnSaveArchivo: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta5,
            },

            ConfigModalResumen:{
                ModalTitle: "Resumen de Pedido",
                ModalNameId: 'ModalForm5',
                ModalSize: 'xl',
                EmitSeccion: EmitEjecuta6,
            },

            oBtnSaveResumen:{
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                ShowBtnSave: false,
                TxtBtnCancel: 'Cerrar',
                EmitSeccion: EmitEjecuta6,
            },

            ConfigModal3:{
                ModalTitle: "Cambiar Estatus Fisico",
                ModalNameId: 'ModalForm7',
                ModalSize: 'xl',
                EmitSeccion: EmitEjecuta7,
                ShowFooter: false
            },
            oBtnSave3:{
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecuta7,
            },

            VerListado: false,
            TipoListado: 0,
            segurity: {},
            obj: {},
            ListaArrayRows: [],  
            ListaArrayRows2: [],  
            StyleTh: Configs.stylesTable.StyleTh,
            StylePr: Configs.stylesTable.StylePr,
            StyleTd: Configs.stylesTable.StyleTd,
            isCotizacion: false,
            RutaFile: '',
        }
    },
    methods: {
		async Lista()
        {
            this.ConfigList.ShowLoader = true;

            await this.$http.get("pedidos",{
                params:{
                    TxtBusqueda: this.Filtro.Nombre,
                    Entrada: this.Filtro.Entrada,
                    Pag: this.Filtro.Pagina,
                    isCotizacion: this.isCotizacion ? 1 : 0,
                    isPedidos: !this.isCotizacion ? 1 : 0
                }
            }).then((res) => {
                this.Filtro.Pagina      = res.data.data.current_page;
                this.Filtro.TotalItem   = res.data.data.total;
                this.ListaArrayRows     = res.data.data.data;
                this.segurity           = res.data.segurity;
            }).finally(()=>{
                this.ConfigList.ShowLoader = false;
            });
        },
        Eliminar(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('pedidos/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.Lista();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },

        viewResumen(item) {
            this.ConfigModalResumen.ModalTitle = 'Resumen de Pedido #'+item.FolioPedido  
            this.bus.$emit('NewModal_'+EmitEjecuta6, item);
        },

   
        ModalGarantia(item)
        {
            let obj = {
                IdGarantia: 0,
                Sitio: 'Pedidos',
                ObjPedido: item,
                TipoVista: 1,
            };
            this.bus.$emit('NewModal_'+EmitEjecuta2,obj);
        },
        CambiarVistaListado()
        {
            if(this.TipoListado == 0){
                this.VerListado = false;
                this.Lista();
            }
            else{
                this.VerListado = true;
                this.ListaFisico();
            }
        },
        ListaFisico()
        {
            this.ConfigListFisico.ShowLoader = true;

            this.$http.get("pedidosFisicos",{
                params:{
                    TxtBusqueda: this.FiltroFisico.Nombre,
                    Entrada: this.FiltroFisico.Entrada,
                    Pag: this.FiltroFisico.Pagina,
                }
            }).then((res) => {
                this.FiltroFisico.Pagina        = res.data.data.current_page;
                this.FiltroFisico.TotalItem     = res.data.data.total;
                this.ListaArrayRows2            = res.data.data.data;
                this.RutaFile                   = res.data.rutaFile;
                this.segurity                   = res.data.segurity;
            }).finally(()=>{
                this.ConfigListFisico.ShowLoader = false;
            });
        },
        EliminarFisico(Id)
        {
            this.$swal(Configs.configEliminar).then((result) =>
            {
                if(result.value)
                {
                    this.$http.delete('pedidosFisicos/'+Id
                    ).then((res) => {
                        this.$swal(Configs.configEliminarConfirm);
                        this.ListaFisico();
                    }).catch(err => {
                        this.$toast.error(err.response.data.message);
                    });
                } 
            });
        },
        ModalEstatus(item){
            // let Obj={
            //     IdEstatusxPedido:0,
            // }
            this.ConfigModal2.ModalTitle=item.FolioPedido;
            this.bus.$emit('MostrarFooter',false);
            this.bus.$emit('NewModal_'+EmitEjecuta4,item);
        },
        ModalArchivo(item){
            this.ConfigModalArchivo.ModalTitle = item.FolioFisico;
            this.bus.$emit('NewModal_'+EmitEjecuta5,item.IdPedidoFisico);
        },


        Regresar(){
            this.$router.push({name:'panelSubMenus', params:{}});
        },
        VerPdf(item){
            console.log('CargarPDF');
            
            let newRequest = {
                IdPedido: item.IdPedido,
            }
            
            this.$http.post('pdfPedidos',newRequest).then((res)=>{

                let pdfView = window.open('');
                pdfView.document.write(
                    "<iframe width='100%' height='100%' src='data:application/pdf;base64, "+encodeURI(res.data.pdf)+"'></iframe>"
                );
            }).catch(err=>{
                console.log(err);
            });
        },
        ModalEstatusFisico(item){
            // let Obj={
            //     IdEstatusxPedido:0,
            // }
            this.ConfigModal3.ModalTitle = item.FolioPedido;
            this.bus.$emit('MostrarFooterFs',false);
            this.bus.$emit('NewModal_'+EmitEjecuta7,item);
        },
    },
    created()
    {
        if(this.pOrigen != undefined){
            sessionStorage.setItem('menuOrigen',JSON.stringify(this.pOrigen));
        }

        let Origen = JSON.parse(sessionStorage.getItem('menuOrigen'));
        
        if(Origen != undefined && Origen != null && Origen != '' ) {
            this.ConfigList.Title = this.ConfigList.Title+' '+Origen;
    
            this.isCotizacion = (Origen == 'Cotizaciones') ? true : false;
            this.ConfigList.Obj.pOrigen = Origen;
            this.ConfigList.GoRoute = 'formpedidos';
            
        }

        this.bus.$off('Delete_'+EmitEjecuta);
        this.bus.$off('List_'+EmitEjecuta);
        this.bus.$off('EmitReturn');

        this.bus.$off('Delete_'+EmitEjecuta3);
        this.bus.$off('List_'+EmitEjecuta3);
        this.bus.$off('MostrarFooter');
        this.bus.$off('MostrarFooterFs');
    },
    mounted()
    {
        this.Lista();
        //this.ListaFisico();
        this.bus.$on('Delete_'+EmitEjecuta,(Id)=>
        {
            this.Eliminar(Id);
        });

        this.bus.$on('List_'+EmitEjecuta,()=>
        {
            this.Lista();
        });

        this.bus.$on('EmitReturn',()=>
        {
            this.Regresar();
        });

        this.bus.$on('Delete_'+EmitEjecuta3,(Id)=>
        {
            this.EliminarFisico(Id);
        });

        this.bus.$on('List_'+EmitEjecuta3,()=>
        {
            this.ListaFisico();
        });
        
        this.bus.$on('MostrarFooter',(val)=>{
            this.ConfigModal2.ShowFooter=val;
        });

        this.bus.$on('MostrarFooterFs',(val)=>{
            this.ConfigModal3.ShowFooter = val;
        });
    }
}
</script>
